module.exports = __webpack_public_path__ + "static/media/add.a75b1d28.svg";